export default "__VITE_ASSET__BSy4nE9v__"